//@ts-nocheck
import React, { useState, useEffect } from 'react'
import styles from './cartItem.module.scss'
import Rate from 'rc-rate'
import 'rc-rate/assets/index.css'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { getCurrentTextLanguage } from '../../../helpers/helpers'
import { Language, Words } from '../../../types/lang'
import { RootState } from '../../../redux/store'
import { addBookToBasket, setBooksToBasket } from '../../../redux/book.slice'
import { AuthUser } from '../../../types/user'
import { addBookToLocalBasket } from '../../../utils/book/addToLocalBasket'
import { Book } from '../../../types/book'
import { getBooksFromLocalBasket } from '../../../utils/book/getBooksFromLocalBasket'

interface CartItemProps {
  image: string
  rate?: number
  rateDisabled?: boolean
  price?: number
  title: Language
  words: Words
  language: string
  id: string
  name: string
  authUser: AuthUser
  book: Book
  addBookToBasket: (id: string) => void
  setBooksToBasket: (basketBooks: BasketBook[]) => void
}

const CartItem = ({
  image = 'https://cdn.pixabay.com/photo/2017/11/10/04/47/image-2935360_960_720.png',
  rate = 0,
  rateDisabled = false,
  price = 12.15,
  title = { eng: 'title', esp: 'título' },
  words,
  language,
  id = '/id',
  name = 'name',
  authUser,
  book,
  addBookToBasket,
  setBooksToBasket,
}: CartItemProps) => {
  const addCartHandler = () => {
    if (authUser) {
      addBookToBasket(book.id)
    } else {
      addBookToLocalBasket(book)
      const basketBooksFromLocalStorage = getBooksFromLocalBasket()
      setBooksToBasket(basketBooksFromLocalStorage)
    }
  }
  return (
    <div className={styles.container}>
      <NavLink to={`/books/${id}/${name}`}>
        <img src={image} alt="" />
      </NavLink>
      <div className={styles.info}>
        <div title={getCurrentTextLanguage(title)} className={styles.title}>
          {getCurrentTextLanguage(title)}
        </div>
        <div className={styles.price}>{`${price} €`}</div>
        <div className={styles.rate}>
          <Rate allowHalf={true} value={rate} disabled={rateDisabled} />
        </div>
        <div className={styles.btnContainer}>
          <div onClick={addCartHandler} className={styles.btn}>
            {words.addToCart}
          </div>
        </div>
      </div>
    </div>
  )
}

let mapStateToProps = (state: RootState) => {
  return {
    words: state.main.words,
    language: state.main.language,
    authUser: state.user.authUser,
  }
}

export default connect(mapStateToProps, {
  getCurrentTextLanguage,
  addBookToBasket,
  setBooksToBasket,
})(CartItem)
